// Project imports
import axios from 'axios';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import * as types from '../actionTypes';
import * as urls from '../urlTypes';
import {
  _getStudyTargetData,
  _setActiveTargets,
  _getSampleWeightedParams,
  _getFormattedDefinitionsListWithSampleWt,
  _setActiveDefinitionExp,
  _updateSelectedDefList,
  _getFormattedTargetList,
  _updateAfterSave,
  _updateValidationList,
  _validateTargetLabel,
  _getUpdatedListForSave,
  _checkIfLatestStudyAvailable,
  _resetTargetLabel,
  _checkDuplicateTarget
} from '../../util/deUtils';
import { toastError } from '../../util/toastUtils';

export const resetDefinitionListState = () => dispatch => {
  dispatch({
    type: types.RESET_DE_STUDY_DEF_STATE,
  });
};

export const _fetchAllDefination = async (accountId, ssid, pn) => {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/${accountId}/${ssid}/${pn}/true?defSort=sc-a,ct-d`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Definition studies');
    return false;
  }
};

// action to get the study defination targets.
export const getStudyTargets = study => async (dispatch, getState) => {
  const state = getState();
  const accountId = state.account.activeAccountId;
  const studies = state.deImportDefiniton.studies.data;

  const { ss, pn, wt } = study;
  const ssid = ss === 'MRI' ? 2 : 1;
  // dispatch({
  //   type: types.DE_RESET_IMPORT_SELECTION,
  // });
  dispatch({
    type: types.GET_DE_STUDY_DEF_REQUEST,
    study,
  });

  const allDefination = await _fetchAllDefination(accountId, ssid, pn);
  if (allDefination) {
    const studyTargets = _getStudyTargetData(allDefination, pn, wt);
    const isLatestStudySelected = _checkIfLatestStudyAvailable(
      study,
      studies
    );
    dispatch({
      type: types.GET_DE_STUDY_DEF_SUCCESS,
      data: studyTargets,
    });
    dispatch({
      type: types.SET_DE_LATEST_STUDY_FLAG,
      isLatestStudySelected,
    });
  } else {
    dispatch({
      type: types.GET_DE_STUDY_DEF_FAILURE,
    });
  }
};

export const getDefinitionsExpList = async (accountId, definitionId) => {
  const url = `${urls.API_GATEWAY_URL}/api/dictionary-service/definitions/expressions/${accountId}/${definitionId}?exprSort=ct-d`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Definition studies');
    return false;
  }
};

export const getDefinitionSampleWt = async sampleWeightedParams => {
  const sampleWtUrl = `${urls.API_GATEWAY_URL}/api/insights/crosstab/samplewgtdpct`;
  try {
    const response = await axios({
      url: sampleWtUrl,
      method: 'post',
      withCredentials: true,
      data: sampleWeightedParams,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get sample weighted');
    return false;
  }
};

export const setActiveStudyTarget = (row, study) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const targetData = state.deImportDefiniton.studyDefinition.studyTargets.data;
  const accountId = state.account.activeAccountId;
  const activeStudy = state.deImportDefiniton.studies.activeStudy;
  const selectedStudy = study || activeStudy;
  const userId = state.login.loginResponse.data.uid;
  const definitionList = state.deImportDefiniton.studyDefinition.available;
  const studyTargets = _setActiveTargets(targetData, row);
  dispatch({
    type: types.GET_DE_STUDY_DEF_SUCCESS,
    data: studyTargets,
  });
  if (!definitionList || !definitionList[row.uniqueId]) {
    const definitionExpList = await getDefinitionsExpList(accountId, row.id);
    let definitionSampleWt = [];
    if (definitionExpList.length > 0) {
      const sampleWeightedParams = await _getSampleWeightedParams(
        definitionExpList,
        selectedStudy,
        accountId,
        userId
      );
      definitionSampleWt = await getDefinitionSampleWt(sampleWeightedParams);
    }
    if (definitionSampleWt) {
      const definitionSampleWtObj = _getFormattedDefinitionsListWithSampleWt(
        definitionExpList,
        definitionSampleWt,
        selectedStudy,
        row
      );
      dispatch({
        type: types.SET_DEFINITION_SAMPLE_WEIGHTED,
        payload: definitionSampleWtObj.formatttedObj,
        folderId: row.uniqueId, // definitionExpList[0].id,
      });
    }
  }
};

export const handleChangeWeightType = weightType => (dispatch, getState) => {
  const state = getState();
  const activeFolderList =
    state.deImportDefiniton.studyDefinition.studyTargets.data;
  const study = cloneDeep(state.deImportDefiniton.studies.activeStudy);
  const updatedFolderList = _getStudyTargetData(
    activeFolderList,
    study.pn,
    weightType.wt,
    true
  );
  const updatedStudy = {
    ...study,
    wt: weightType.wt,
    dv: weightType.dv,
  };
  const activeFolder = updatedFolderList.find(
    folder => folder.isActive === true
  );
  if (activeFolder) {
    dispatch(setActiveStudyTarget(activeFolder, updatedStudy));
  }
  dispatch({
    type: types.SET_DE_ACTIVE_STUDY_WEIGHT,
    activeStudy: updatedStudy,
    data: updatedFolderList,
  });
};

export const getImpactedDefinitions = (data, row, isSelected, isAll) => {
  if (row) {
    return row;
  }
  if (isAll && isSelected) {
    return data;
  }
  return filter(data, def => def.isActive === true);
};

export const setSelectedDefinition = (
  isSelected,
  row,
  folderId,
  isAll = false
) => (dispatch, getState) => {
  const state = getState();
  if (state.deImportDefiniton.isEditTargetDefinition) {
    return false
  }
  const definitionsAvailable =
    state.deImportDefiniton.studyDefinition.available;
  const study = state.deImportDefiniton.studies.activeStudy;
  const { pn, wt } = study;
  const selectedDefinitionsForImport =
    state.deImportDefiniton.studyDefinition.selected.data;
  const productNo = row ? row.pn : pn;
  const weightType = row ? row.wt : wt;
  const importValidation =
    state.deImportDefiniton.studyDefinition.selected.importValidations;
  const definitionSampleWtData =
    definitionsAvailable[`${productNo}_${weightType}_${folderId}`];
  const updatedDefinitionLExpist = _setActiveDefinitionExp(
    definitionSampleWtData,
    isSelected,
    row,
    isAll
  );
  dispatch({
    type: types.SET_DEFINITION_SAMPLE_WEIGHTED,
    payload: updatedDefinitionLExpist,
    folderId: `${productNo}_${weightType}_${folderId}`,
  });
  const finalDefList = getImpactedDefinitions(
    definitionSampleWtData.data,
    row,
    isSelected,
    isAll
  );
  const filterFinalDefList = row ? finalDefList : finalDefList.filter(item => !item.isDisabled);
  const selectedDefForImport = _updateSelectedDefList(
    row,
    isSelected,
    isAll,
    filterFinalDefList,
    selectedDefinitionsForImport
  );
  const updatedValidationList = _updateValidationList(
    isSelected,
    filterFinalDefList,
    importValidation,
    folderId,
    selectedDefForImport,
    isAll
  );
  dispatch({
    type: types.DE_SET_DEFINITION_FOR_IMPORT,
    payload: selectedDefForImport,
    folderId,
    validationData: updatedValidationList,
  });
};

export const saveTargetsList = async (accountId, targetList, isValidate) => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/save/${accountId}/${isValidate}`;
  const targetListData = targetList.map(item => {
    const data = {
      ...item,
      tn: item.tn.replace(/’/g, "'"),
    }
    return data;
  })
  try {
    const response = await axios({
      url,
      method: 'post',
      withCredentials: true,
      data: targetListData,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to save targets');
    return false;
  }
};

export const setIsEditTargetDefinition = (isEditable) => dispatch => {
  dispatch({
    type: types.DE_IS_EDIT_TARGET_DEFINITION,
    payload: isEditable,
  });
};

export const setIsImportClicked = (isClicked) => dispatch => {
  dispatch({
    type: types.DE_IS_IMPORT_TARGET_DEFINITION,
    payload: isClicked,
  });
};

// Saving targets to DB
export const saveTargets = () => async (dispatch, getState) => {
  const state = getState();
  if (state.deImportDefiniton.isEditTargetDefinition) {
    dispatch(setIsImportClicked(true));
    return true
  }
  const targetsToImport = state.deImportDefiniton.studyDefinition.selected.data;
  const available = state.deImportDefiniton.studyDefinition.available;
  const importValidation =
    state.deImportDefiniton.studyDefinition.selected.importValidations;
  const accountId = state.account.activeAccountId;
  const getValidTargetsForSave = _getUpdatedListForSave(
    targetsToImport,
    importValidation
  );
  const formattedList = _getFormattedTargetList(getValidTargetsForSave);
  /* line 327 - 333 was commented as per ticket PLAT-10748
  Now removed to fix PLAT-11737
  const formattedList = _getFormattedTargetList(targetsToImport); */
  dispatch(setIsEditTargetDefinition(false));
  const savedTargetList = await saveTargetsList(
    accountId,
    formattedList,
    false
  );
  const updatedSelectionList = _updateAfterSave(
    savedTargetList,
    targetsToImport,
    importValidation,
    available
  );
  dispatch({
    type: types.DE_SAVE_TARGETS,
    payload: updatedSelectionList.data,
    validationData: updatedSelectionList.importValidations,
    hasSuccess: updatedSelectionList.hasSuccess,
    available: updatedSelectionList.available,
  });
  return true
};

// validate target label
export const validateTargetLabel = definition => async (dispatch, getState) => {
  const state = getState();
  const accountId = state.account.activeAccountId;
  const originalList = getState().deImportDefiniton.studyDefinition.selected
    .data;
  const importValidations =
    state.deImportDefiniton.studyDefinition.selected.importValidations;
  const formattedList = _getFormattedTargetList([definition]);
  let duplicateTarget = [];
  if( originalList.length > 0){
    duplicateTarget = _checkDuplicateTarget(originalList, definition)
  }
  const editedTarget = await saveTargetsList(accountId, formattedList, true);
  if(editedTarget){
    editedTarget[0].isDuplicate = false
  }
  if(duplicateTarget.length > 0){
    editedTarget[0].isDuplicate = true
  }
  const updatedSelectionList = _validateTargetLabel(
    editedTarget,
    importValidations,
    definition.di,
    originalList,
  );
  dispatch({
    type: types.DE_EDIT_TARGETS,
    payload: updatedSelectionList.selectedList,
    importValidation: {
      errors: updatedSelectionList.errors,
      valid: updatedSelectionList.valid,
      duplicateTargetList: updatedSelectionList.duplicateTargetList,
    },
    folderId: definition.di,
  });
  dispatch(setIsEditTargetDefinition(false));
  if (getState().deImportDefiniton.isImportClicked) {
    dispatch(saveTargets())
    dispatch(setIsImportClicked(false));
  }
  const failedTargetList = editedTarget.filter(item => item.success === 0);
  if(failedTargetList.length > 0 || duplicateTarget.length > 0){
    return false
  }
  return true
};

export const setOrginalTargetName = ( row ) => async (dispatch, getState) => {
  const state = getState();
  const importValidations =
    state.deImportDefiniton.studyDefinition.selected.importValidations;
  const deImportTarget = state.deImportDefiniton.studyDefinition.selected.data;
  const rowIndex = findIndex(
    deImportTarget,
    def => def.ui === row.ui
  );
  const payload = cloneDeep(deImportTarget);
  Object.assign(payload[rowIndex], { tn: deImportTarget[rowIndex].originalTn });
  dispatch({
    type: types.DE_SET_ORIGINAL_TARGET_NAME,
    payload
  });
  const updatedTargetList = _resetTargetLabel(
    row,
    importValidations,
    row.di,
  );
  dispatch({
    type: types.DE_SET_IMPORT_VALIDATIONS,
    importValidation: {
      errors: updatedTargetList.errors,
      valid: updatedTargetList.valid,
      duplicateTargetList: updatedTargetList.duplicateTargetList,
    },
    folderId: row.di,
  });
  dispatch(setIsEditTargetDefinition(false));
}